import { Loading } from '@/components/loading';
import { useAuthContext } from '@/modules/Auth/Auth.context';
import { AsyncState } from '@/state';
import { RouterProvider } from 'react-router-dom';

import { router } from '../Router';

export default function App() {
  const { resetAuth, authenticationStatus } = useAuthContext();

  if (authenticationStatus === 'LOADING') {
    return <Loading />;
  }

  const appRouter = router(authenticationStatus, resetAuth);

  return (
    <AsyncState.Provider>
      <RouterProvider router={appRouter} />
    </AsyncState.Provider>
  );
}
